module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h3', [_vm._v("Object: " + _vm._s(_vm.artifactComponentNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": _vm.comms_add_url,
      "disable_add_entry": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                    Workflow\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v("\n                            " + _vm._s(_vm.artifactStatusDisplay)), _c('br')])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "main-column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.showDocumentArtifactComponent) ? _c('div', {
    staticClass: "row"
  }, [_c('DocumentArtifact', {
    key: _vm.updateDocumentArtifactBindId,
    ref: "document_artifact",
    attrs: {
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPhysicalArtifactComponent) ? _c('div', {
    staticClass: "row"
  }, [_c('PhysicalArtifact', {
    key: _vm.updatePhysicalArtifactBindId,
    ref: "physical_artifact",
    attrs: {
      "readonlyForm": !_vm.canUserAction
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (_vm.canUserAction) ? _c('div', {
    staticClass: "navbar navbar-fixed-bottom",
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [(_vm.showSpinner && _vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('exit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveExit()
      }
    }
  }, [_vm._v("Save and Exit")]), _vm._v(" "), (_vm.showSpinner && !_vm.showExit) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": "",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save('noexit')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Saving")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save and Continue")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1783d9aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/artifact/artifact.vue
// module id = 926
// module chunks = 0